import { render, staticRenderFns } from "./ContactEditDefault.vue?vue&type=template&id=6ff0d216&scoped=true"
import script from "./ContactEditDefault.vue?vue&type=script&lang=ts"
export * from "./ContactEditDefault.vue?vue&type=script&lang=ts"
import style0 from "./ContactEditDefault.vue?vue&type=style&index=0&id=6ff0d216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0d216",
  null
  
)

export default component.exports